import { Path, Point } from 'fabric';

import { Page } from 'editor/src/store/design/types';

import getSpreadBackgroundPolygons from '../Page/getSpreadBackgroundPolygons';

export default function getRulerBounds(pages: Page[] | undefined, width: number, height: number) {
  const bounds = (pages || []).flatMap((page) => {
    const points = getSpreadBackgroundPolygons(
      page.groups.mediabox || [],
      page.groups.content || [],
      page.groups.bleed || [],
      undefined,
      { left: page.x, top: page.y },
      { angleDeg: 0, angleRad: 0, canvasCenter: new Point(0, 0) },
      (n) => n,
      false,
    ).flat(2);
    if (!points.length) {
      return [];
    }
    let left = Math.min(...points.map((p) => p[0]));
    let top = Math.min(...points.map((p) => p[1]));
    let right = Math.max(...points.map((p) => p[0]));
    let bottom = Math.max(...points.map((p) => p[1]));
    const trim = page.groups.bleed?.find((b) => b.name === 'Trim');
    if (trim?.extra?.inner_path) {
      const path = new Path(trim.extra.inner_path);
      left = Math.max(left, page.x + trim.extra.inner_x);
      top = Math.max(top, page.y + trim.extra.inner_y);
      right = Math.min(right, page.x + trim.extra.inner_x + path.width);
      bottom = Math.min(bottom, page.y + trim.extra.inner_y + path.height);
    }
    return [{ left, top, right, bottom }];
  });
  if (!bounds.length) {
    return { left: 0, top: 0, width, height };
  }
  const left = Math.min(...bounds.map((b) => b.left));
  const top = Math.min(...bounds.map((b) => b.top));
  const right = Math.max(...bounds.map((b) => b.right));
  const bottom = Math.max(...bounds.map((b) => b.bottom));
  return right > left && bottom > top
    ? { left, top, width: right - left, height: bottom - top }
    : { left: 0, top: 0, width, height };
}
